"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Tag_1 = require("@/common/cards/Tag");
const utils_1 = require("@/common/utils/utils");
const PlanetaryTrack_vue_1 = __importDefault(require("@/client/components/pathfinders/PlanetaryTrack.vue"));
const PlanetaryTracks_1 = require("@/common/pathfinders/PlanetaryTracks");
exports.default = (0, vue_1.defineComponent)({
    name: 'PlanetaryTracks',
    props: {
        tracks: {
            type: Object,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
    },
    components: {
        PlanetaryTrack: PlanetaryTrack_vue_1.default,
    },
    data() {
        return {
            venus: Tag_1.Tag.VENUS,
            earth: Tag_1.Tag.EARTH,
            mars: Tag_1.Tag.MARS,
            jovian: Tag_1.Tag.JOVIAN,
            moon: Tag_1.Tag.MOON,
            range: (0, utils_1.range)(23),
            rewards: PlanetaryTracks_1.PlanetaryTracks.initialize(),
        };
    },
});
